import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/grupo-de-rotas-de-saida');
  }
}

export default new Service();
